<section class="question" (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <header class="question__header has-person-id">
    <h2 class="question__assessment-title">{{assessment.credentialCode}} - {{assessment.year}} - Quarter {{assessment.sequence}}</h2>
    <h1 class="question__number">Question {{question.sequence}} of {{assessment.questionCount}} :
      <span *ngIf="isAnswerCorrect === true" class="question__result question__result--correct">Correct</span>
      <span *ngIf="isAnswerCorrect === false" class="question__result question__result--incorrect">Incorrect</span>
      <span *ngIf="isAnswerCorrect === null" class="question__result question__result--incorrect">No Answer Selected</span>
    </h1>
    <div class="person-id">{{personId}}</div>
  </header>
  <div class="question__description rte-content watermarked" [innerHtml]="question.stem | safeHtml">
  </div>
  <div class="question-choices">
    <div [ngClass]="selectedAnswer==option.questionOptionId?'question-choice question-choice-result question-choice-result--selected':'question-choice question-choice-result'"
      *ngFor="let option of question.options; let i = index">
      <div class="question-choice-result__text-wrap">
        <span [ngClass]="option.isAnswer?'question-choice-result__icon icon icon--check question-choice-result__icon--correct':'question-choice-result__icon icon icon--close question-choice-result__icon--incorrect'"></span>
        <div class="question-choice__text" [innerHtml]="option.text | safeHtml"></div>
      </div>
      <p class="question-choice-result__explanation" [innerHtml]="option.explanation | safeHtml"></p>
    </div>
  </div>
  <form>
    <div class="form-actions form-actions--reverse">
      <input *ngIf="question.nextQuestionId" type="button" (click)="nextQuestion()" class="button form-actions__item"
        value="Next Question" />
      <a routerLink="/assessment" class="button button--bare form-actions__item">Exit</a>
    </div>
    <small class="copyright">Copyright &copy; {{currentYear}}. The National Board for Respiratory Care, Inc. All rights
      reserved. FOR CONFIDENTIAL PERSONAL USE ONLY - DO NOT COPY, DISCLOSE, OR
      DISTRIBUTE ANY PART OR PORTION</small> 
  </form>
</section>